import { Inject, Injectable } from '@angular/core';
import { TPlani8EnvironmentVars } from '@monorepo/types';

export const Plani8EndPoints = {
  //Factory Listing APIs
  GET_FACTORY_LIST: '/api/v1/account/factories/list',
  GET_LINE_WISE_EFFICIENCY: '/api/v1/lineWiseEfficiency/:factoryId',
  ADD_UPDATE_LINE_EFFICIENCY: '/api/v1/lineWiseEfficiency/addOrUpdate',
  MACHINE_AVAILABILITY_TEMPLATE_DOWNLOAD: '/api/v1/machineInventory/template/download',
  MACHINE_AVAILABILITY_UPLOAD: '/api/v1/machineInventory/upload/:factoryId',

  OPERATION_BREAKDOWN_TEMPLATE_DOWNLOAD: '/api/v1/operationBreakdown/template/download',
  OPERATION_BREAKDOWN_UPLOAD: '/api/v1/operationBreakdown/upload/:otlId/:productType',

  //Factory Config Setup APIs
  GET_EFFICIENCY_CONFIG_LIST: '/api/v1/config/efficiency/listing',
  UPDATE_EFFICIENCY_CONFIG: '/api/v1/config/efficiency/addUpdate',
  GET_BENCHMARKING_CONFIG_LIST: '/api/v1/config/benchmark/listing',
  UPDATE_BENCHMARKING_CONFIG: '/api/v1/config/benchmark/addUpdate',
  GET_OTL_OPL_CONFIG_LIST: '/api/v1/config/orderTrackingLevel/listing',
  UPDATE_OTL_OPL_CONFIG: '/api/v1/config/orderTrackingLevel/addUpdate',
  GET_SED_CONFIG: '/api/v1/config/sedAllowance',
  UPDATE_SED_CONFIG: '/api/v1/config/sedAllowance/addUpdate',
  GET_DATES_FROM_PLAN_CONFIG: '/api/v1/config/dateFromPlanConfig',
  GET_TNA_TARGET_UPDATES_CONFIG: '/api/v1/config/autoUpdateConfig',
  UPDATE_DATES_FROM_PLAN_CONFIG: '/api/v1/config/dateFromPlanConfig/addUpdate',
  UPDATE_TNA_TARGET_UPDATES_CONFIG: '/api/v1/config/autoUpdateConfig/addUpdate',

  //UOM APIs
  GET_FACTORY_UOM: '/api/v1/uom/view/:factoryId',
  UPDATE_FACTORY_UOM: '/api/v1/uom/addUpdate/:factoryId',

  //ORDER ATTRIBUTES Types APIs
  GET_ORDER_ATTRIBUTES: '/api/v1/orderAttributes/listing',
  GET_ORDER_ATTRIBUTES_TYPES: '/api/v1/orderAttributes/types',
  ADD_UPDATE_ORDER_ATTRIBUTES: '/api/v1/orderAttributes/addUpdate',
  DELETE_ORDER_ATTRIBUTES: '/api/v1/orderAttributes/delete',
  ALLOCATE_PRODUCTS_TYPES: '/api/v1/productTypes/factories/allocate',

  //Learning Curve APIs
  GET_LEARNING_CURVES: '/api/v1/learningCurve/view',
  ADD_UPDATE_LEARNING_CURVE: '/api/v1/learningCurve/addEdit',
  ADD_LEARNING_CURVE_DAY: '/api/v1/learningCurve/incrementDayCount',
  DELETE_LEARNING_CURVES: '/api/v1/learningCurve/delete',

  //Factory Shift-setup APIs
  GET_FACTORY_SHIFTS: '/api/v1/shift/:factoryId',
  ADD_EDIT_FACTORY_OPERATOR_COUNT: '/api/v1/shift/operatorCount/addEdit/:factoryId',
  RESET_FACTORY_OPERATOR_COUNT: '/api/v1/shift/operatorCount/resetToDefault/:factoryId',

  //Employee Listing APIs
  GET_EMPLOYEE_LIST: '/api/v1/employee/listing',
  GET_PENDING_TNA_STEPS: '/api/v1/employee/getPendingTNASteps',
  ARCHIVE_USER_EMPLOYEE_LIST: '/api/v1/employee/archive',
  CREATE_UPDATE_EMPLOYEE: '/api/v1/employee/createOrUpdate',
  GET_TEAM_LIST: '/api/v1/team/listing',
  CREATE_UPDATE_TEAM: '/api/v1/team/createOrUpdate',
  DELETE_TEAM: '/api/v1/team/delete',
  ADD_EDIT_FACTORY_WORKING_HOURS: '/api/v1/shift/workingHours/addEdit/:factoryId',
  RESET_FACTORY_WORKING_HOURS: '/api/v1/shift/workingHours/resetToDefault/:factoryId',

  //HOLIDAYS
  GET_FACTORY_HOLIDAYS: '/api/v1/holidays/:factoryId',
  ADD_EDIT_FACTORY_HOLIDAYS: '/api/v1/holidays/addEdit/:factoryId',
  DELETE_FACTORY_HOLIDAYS: '/api/v1/holidays/delete/:factoryId',

  //Factory Product-line-efficiency APIs
  GET_PRODUCT_LINE_EFFICIENCY_LIST: '/api/v1/linewiseEfficiency/list/:factoryId',
  ADD_EDIT_PRODUCT_LINE_EFFICIENCIES: '/api/v1/linewiseEfficiency/addEdit/:factoryId',
  DELETE_PRODUCT_LINE_EFFICIENCY: '/api/v1/linewiseEfficiency/delete/:factoryId',

  //TNA TEMPLATE LIST
  GET_TNA_TEMPLATE_LIST: '/api/v1/tna/templateListing',
  UPDATE_TNA_TEMPLATE_NAME: '/api/v1/tna/template/updateName',
  DELETE_TNA_TEMPLATE: '/api/v1/tna/deleteTemplate',
  COPY_TNA_TEMPLATE: '/api/v1/tna/copyTemplate/:templateId',

  //TnA Default Steps list
  GET_TNA_DEFAULT_STEPS: '/api/v1/defaultTnaSteps',
  CREATE_TNA_TEMPLATE: '/api/v1/tna/createTemplate',

  //TnA Template details
  GET_TNA_TEMPLATE_DETAILS: '/api/v1/getTnaTemplateByName',
  ADD_EDIT_TNA_TEMPLATE_STEP: '/api/v1/tna/template/addOrEditStep',
  DELETE_TNA_TEMPLATE_STEP: '/api/v1/tna/template/deleteStep',
  DOWNLOAD_TNA_DETAILS: '/api/v1/tnaTemplate/download/:templateId',
  ASSIGN_TNA_TO_ORDERS: '/api/v1/tnaOrderTemplate/assignTemplate',

  //TnA Order Template APIs
  GET_TNA_ORDER_TEMPLATE: '/api/v1/tnaOrderTemplate/byOrderTnaId/:tnaOrderTemplateId',
  UPDATE_STEP_BY_TEMPLATE_ID: '/api/v1/tnaOrderTemplate/updateStepByTemplateId',
  AUTO_UPDATE_TARGET_DATES: '/api/v1/tnaOrderTemplate/computeTnaTargetDates',
  ADD_EDIT_TNA_ORDER_TEMPLATE_STEP: '/api/v1/tnaOrderTemplate/addOrEditStep',
  DELETE_TNA_ORDER_TEMPLATE_STEP: '/api/v1/tnaOrderTemplate/deleteStep',
  DOWNLOAD_TNA_ORDER_TEMPLATE: '/api/v1/tnaOrderTemplate/download/:templateId',

  //Order list APIS
  ORDER_LISTING: '/api/v1/orders/listing',
  ORDER_DETAILS_MODEL: '/api/v1/availableOrderAttributes',
  DOWNLOAD_SAMPLE_ORDERS_TEMPLATE: '/api/v1/orders/template/download',
  ORDER_LIST_UPLOAD_XLSX: '/api/v1/orders/upload',
  ORDER_LISTING_FROM_TNA: '/api/v1/orders/listing/fromTnaTemplate',
  ORDER_LIST_DOWNLOAD_EXCEL_ERROR_SHEET: '/api/v1/orders/download/errorSheet/:key',
  DELETE_ORDERS: '/api/v1/orders/delete/byOTLId',

  //TnA Board
  GET_TNA_BOARD_LISTING: '/api/v1/tnaBoard/listing',
  GET_TNA_ORDER_DETAILS: '/api/v1/orderTna/getOrderDetails/:orderId',
  GET_TNA_ORDER_PROGRESS: '/api/v1/tnaBoard/orderProgress/byId/:orderId',
  GET_TNA_BOARD_FILTERS: '/api/v1/tnaBoard/filters',
  GET_TNA_BOARD_FILTERS_SEARCH: '/api/v1/tnaBoard/filters/search',

  //Order to (single/multiple) factory allocation APIs
  ORDER_SINGLE_FACTORY_ALLOCATION: '/api/v1/orders/allocate/bulk',
  ORDER_VIEW_FACTORY_ALLOCATION: '/api/v1/orders/details/colorlevelallocation/byOTLId',
  ORDER_CREATE_SPLIT_VIEW_FOR_FACTORIES: '/api/v1/orders/allocate/createSplitView/byOTLId',
  ORDER_ALLOCATION_MULTIPLE_FACTORIES: '/api/v3/orders/allocate/byOTLId',

  //TNA STEPS
  GET_TNA_ORDER_STEP_LIST: '/api/v1/tnaOrderTemplate/tnaOrderStep/listing',
  GET_TNA_ORDER_STEP: '/api/v1/tnaOrderStep/byId/:tosId',
  UPDATE_TNA_STEP: '/api/v1/tnaOrderTemplate/tnaOrderStep/update',
  BULK_COMPLETE_TNA_ORDER_STEPS: '/api/v1/tnaOrderTemplate/tnaOrderStep/bulkComplete',

  //TNA APPROVALS
  GET_TNA_STEP_APPROVAL_LIST: '/api/v1/tnaStepApproval/listing',
  GET_TNA_STEP_APPROVAL_DETAILS: '/api/v1/tnaStepApproval/byId/:tosId',
  GET_EMPLOYEES_FOR_STEP_APPROVAL: '/api/v1/tnaStepApproval/getEmployees/:approvalType',
  REQUEST_TNA_STEP_APPROVAL: '/api/v1/tnaStepApproval/createRequest',
  GET_TNA_STEP_APPROVAL_PENDING_LIST: '/api/v1/tnaStepApproval/pendingRequests/listing',
  GET_TNA_STEP_APPROVAL_PENDING_DETAILS: '/api/v1/tnaStepApproval/pendingRequest/byId/:approvalId',
  UPDATE_TNA_STEP_APPROVAL: '/api/v1/tnaStepApproval/approveOrReject',

  //Shift
  GET_LL_SHIFT_INFO: '/api/v1/line/shift/:factoryId',
  LL_ADD_EDIT_WORKING_HOURS: '/api/v1/shift/line/workingHours/addEdit/:factoryId',
  LL_RESET_WORKING_HOURS: '/api/v1/shift/line/workingHours/resetToDefault/:factoryId',
  UPDATE_DEFAULT_WORKFORCE_COUNT: '/api/v1/defaultWorkforceCount/addEdit',
  UPDATE_DEFAULT_WORKING_HOURS: '/api/v1/defaultWorkingHours/addEdit/:factoryId',
  ADD_EDIT_WORKFORCE_COUNT: '/api/v1/shift/workforceCount/addEdit/:factoryId',
  WORKFORCE_RESET_TO_DEFAULT: '/api/v1/shift/workforceCount/resetToDefault/:factoryId',
  ADD_EDIT_LINE_WORKFORCE_COUNT: '/api/v1/shift/line/workforceCount/addEdit/:factoryId',
  RESET_LINE_WORKFORCE_COUNT: '/api/v1/shift/line/workforceCount/resetToDefault/:factoryId',
  GET_ORG_HIERARCHY: '/api/v1/account/factories/orgHierarchy/:factoryId',
  GET_ALL_SHIFTS_BY_FACTORY: '/api/v1/shift/list/:factoryId',
  GET_ALL_SHIFTS: '/api/v1/shift/account/names',
  ADD_EDIT_SHIFT: '/api/v1/shift/addEdit',
  GET_SHIFT_BY_ID: '/api/v1/shiftId/:shiftId',

  //LL board
  LL_BOARD_LISTING: '/api/v1/llBoard/listing',
  LL_GET_STRIP_EFFICIENCY: '/api/v1/llBoard/strip/efficiency/view/:stripId',
  LL_EDIT_STRIP_EFFICIENCY: '/api/v1/llBoard/strip/efficiency/addEdit/:stripId',
  LL_RESET_STRIP_EFFICIENCY: '/api/v1/llBoard/strip/efficiency/reset/:stripId/:efficiencyConfigType',
  LL_GET_OTL_EFFICIENCY: '/api/v1/llBoard/orderTna/efficiency/view/:orderTnaId',
  LL_EDIT_OTL_EFFICIENCY: '/api/v1/llBoard/orderTna/efficiency/addEdit/:orderTnaId',
  LL_RESET_OTL_EFFICIENCY: '/api/v1/llBoard/orderTna/efficiency/reset/:orderTnaId/:efficiencyConfigType',
  LL_ORDER_LISTING: '/api/v1/llBoard/otlListing/:bucketInfo',
  LL_OPL_LISTING: '/api/v1/llboard/oplListing',
  LL_PLANNING_DETAILS: '/api/v1/llBoard/details/planning/byOTLId',
  LL_PLANNED_ORDER_PROGRESS: '/api/v1/llBoard/orderProgress/planned/view/:stripId',
  LL_LOAD_ORDER: '/api/v1/llBoard/loadMultipleOrders',
  LL_FILTERS_API: '/api/v1/llBoard/filters',
  LL_FILTERS_SEARCH_API: '/api/v1/llBoard/filters/search',
  LL_OPL_DETAILS: '/api/v1/llBoard/oplDetails/:stripId',
  LL_JIT_STRIP: '/api/v1/llBoard/strip/actions/jit',
  LL_SPLIT_STRIP: '/api/v1/llBoard/strip/actions/split',
  LL_POLL_STATUS: '/api/v1/llBoard/poll/status',
  LL_SYNC_BOARD: '/api/v1/llBoard/actions/sync',
  LL_RECALIBRATE_API: '/api/v1/llBoard/actions/recalibrate',
  LL_GET_TASK_MANAGER: '/api/v1/llBoard/taskManager',
  LL_UNLOAD_STRIP_REMOVE_MULTIPLE_ORDERS: '/api/v1/llBoard/strip/actions/unloadMultiple',
  LL_SHIFT_ORDER: '/api/v1/llBoard/strip/actions/shiftMultiple',
  LL_UNLOAD_STRIP_MOVE_PARTIALLY: '/api/v1/llBoard/strip/actions/unloadPartially',
  LL_ADD_EDIT_NOTE: '/api/v1/llBoard/strip/actions/addEditNote',
  LL_STRIP_PLANNED_NUMBERS: '/api/v1/llBoard/strip/actions/plannedNumbers',
  LL_LOAD_ORDER_THRESHOLD: '/api/v1/llBoard/loadOrderDateRangeAndSubjects',
  LL_REPLAN_STRIP: '/api/v1/llBoard/strip/actions/rePlan',
  LL_LINK_STRIP: '/api/v1/llBoard/strip/actions/link',
  LL_UNLINK_STRIP: '/api/v1/llBoard/strip/actions/unlink/:stripId',
  LL_LINK_CONTINUE_STRIP: '/api/v1/llBoard/strip/actions/link/continue',
  LL_MERGE_STRIPS: '/api/v1/llBoard/strip/actions/merge',
  LL_GET_QTY_BY_DATE: '/api/v1/llBoard/strip/actions/getQtyByDate',
  LL_GET_QTY_BY_DELAY: '/api/v1/llBoard/strip/actions/getQtyByDelay',
  PULL_FORWARD_STRIP: '/api/v1/llBoard/strip/actions/pull',
  LL_SEARCH: '/api/v1/llBoard/strip/search',
  CLOSE_OPL: '/api/v1/llBoard/strip/actions/closeOpl',

  //HL board
  HL_BOARD_LISTING: '/api/v1/hlBoard/listing',
  HL_BOARD_FILTERS_API: '/api/v1/hlBoard/filters',
  HL_BOARD_FILTERS_SEARCH_API: '/api/v1/hlBoard/filters/search',
  HL_SYNC_BOARD: '/api/v1/hlBoard/sync',
  HL_BOARD_POLL_STATUS: '/api/v1/hlBoard/status',
  HL_OPL_CAPACITIES_INFO: '/api/v1/hlBoard/opl/listing',
  HL_OTL_CAPACITIES_INFO: '/api/v1/hlBoard/otl/listing',
  HL_OTL_FILTERS_API: '/api/v1/hlBoard/otl/dailyView/filters',
  HL_OTL_FILTERS_SEARCH_API: '/api/v1/hlBoard/otl/dailyView/filters/search',

  //Order Details APIS
  START_ORDER_DETAILS_SYNC: '/api/v1/orders/sync/:otlId',
  GET_ORDER_DETAILS_POLL_STATUS: '/api/v1/orders/sync/poll/status/:otlId',
  GET_ORDER_DETAILS_PLANNING_CARD: '/api/v1/llBoard/details/planning/byOTLId',
  GET_ORDER_DETAILS_HEADER: '/api/v1/orders/details/byOTLId',
  EDIT_ORDER_DETAILS_HEADER: '/api/v1/orders/details/byOTLId/edit',
  MARK_ORDER_NOT_REQUIRED: '/api/v1/orders/details/byOTLId/markNotRequired',
  DEFAULT_COUNT_EDIT_ORDER_DETAILS_HEADER: '/api/v1/orders/details/byOTLId/editManPower',
  GET_ORDER_DETAILS_LEARNING_CURVE_ORDER_EFFICIENCY: '/api/v1/orders/details/learningCurveAndOrderEfficiency/byOTLId',
  VIEW_ORDER_DETAILS_LEARNING_CURVE: '/api/v1/learningCurve/:id',
  EDIT_ORDER_DETAILS_LEARNING_CURVE_ORDER_EFFICIENCY: '/api/v1/orders/details/learningCurveAndOrderEfficiency/addEdit',
  GET_ORDER_DETAILS_ALL_LEARNING_CURVES: '/api/v1/learningCurves',
  GET_OPTIMAL_PLAN_BY_OPL_ID: '/api/v1/optaplanner/find-optimal-load-plan',
  LOAD_OPL_STRIPS: '/api/v1/llBoard/loadOplStrips',

  //Order Po Details Card
  GET_PO_CARD_DETAILS: '/api/v1/orders/details/po/byOTLId',
  ADD_EDIT_PO_CARD_ORDER: '/api/v1/orders/details/po/edit',
  DELETE_PO_CARD_ORDER: '/api/v1/orders/details/po/delete',
  RESET_LC_FROM_ORDER_DETAILS: '/api/v1/orders/details/learningCurve/delete',
  DOWNLOAD_PO_CARD_SAMPLE_DETAILS: '//api/v1/actuals/template/download',
  PRODUCED_QTY_UPLOAD_XLSX: '/api/v1/actuals/upload',
  PRODUCED_QTY_EXCEL_ERROR_SHEET: '/api/v1/actuals/download/errorSheet/:key',
  GET_FACTORY_NAMES: '/api/v1/account/factories/nameAndId',
  GET_PO_COLOR_SIZE_QTY_DATA: '/api/v1/orders/byColorLevelHash',
  UPDATE_PO_COLOR_QTY_BY_RATIO: '/api/v1/orders/byColorLevelHash/edit/qty/byColor',
  UPDATE_PO_COLOR_SIZE_QTY_MANUALLY: '/api/v1/orders/byColorLevelHash/addEditColorsOrSizes',

  //Order Allocation Card
  GET_ALLOCATION_CARD_DETAILS: '/api/v2/orders/details/allocation/byOTLId/:otlId',
  GET_ORDER_TIMELINE_CARD_DETAILS: '/api/v1/orders/details/processMapping/byOTLId/:otlId',
  GET_LINEWISE_PLANNED_QTY_CARD_DETAILS: '/api/v1/orders/details/byOTLId/lineWisePlannedQtyCard',
  GET_OPERATION_BREAKDOWN_DETAILS: '/api/v1/operationBreakdown/:otlId',
  VIEW_ORDER_ALLOCATION_EDIT_FLOW: '/api/v3/orders/details/allocation/byOTLId/:otlId',
  VIEW_ORDER_FACTORY_SPLIT_FLOW: '/api/v2/orders/allocate/createSplitView/byOTLId',
  DELETE_ALLOCATION: '/api/v1/orders/deAllocate/byOPLId',

  //LL Board Learning curve config
  GET_LL_LEARNING_CURVE_INFO: '/api/v1/llBoard/strip/learningCurve/:stripId',
  LL_INCREMENT_LC_DAY_COUNT: '/api/v1/llBoard/strip/learningCurve/incrementDayCount/:stripId',
  LL_ADD_EDIT_LC_EFFICIENCY: '/api/v1/llBoard/strip/learningCurve/addEdit/:stripId',
  LL_DELETE_LC_STRIP: '/api/v1/llBoard/strip/learningCurve/delete/byStripId',
  GET_LL_LEARNING_CURVE_BY_FACTORY_OTL: '/api/v1/llBoard/learningCurve/byFactoryAndOTL',
  LL_ADD_EDIT_LC_BY_FACTORY_OTL: '/api/v1/llBoard/learningCurve/addEdit/byFactoryAndOTL',
  LL_RESET_LC_BY_FACTORY_OTL: '/api/v1/llBoard/learningCurve/delete/byFactoryAndOTL',

  //Line level Strip Listing
  FETCH_LINE_LEVEL_STRIPS: '/api/v1/lineLevel/strip/listing/:lineSubject',

  // Metabase Dashboards
  GET_PLANNER_METABSE_URL: '/api/v1/metabase/getPlannerDashboard',
  GET_MERCHANDISER_METABSE_URL: '/api/v1/metabase/getMerchandiserDashboard',
  GET_ANALYTICS_DASHBOARD_URL: '/api/v1/metabase/getOIAppDashboard',

  // Material In-house
  GET_MATERIAL_IN_HOUSE_DETAILS: '/api/v2/materialInHouse/details/byStripId/:stripId',
  GET_MATERIAL_IN_HOUSE_BY_OTL: '/api/v2/materialInHouse/details/byOTLId/:otlId',

  // Factory Allocation
  GET_FACTORY_ALLOCATION_FILTERS: '/api/v1/allocations/getOPLListingFilters',
  GET_FACTORY_ALLOCATION_LISTING: '/api/v1/allocation/oplListing',
  FACTORY_ALLOCATION_PARTIAL: '/api/v4/orders/partialAllocation/byOPLId',

  // Order Checklist
  GET_ORDER_CHECKLIST_LISTING: '/api/v1/orderChecklist/listing',
  SUBMIT_ORDER_CHECKLIST: '/api/v1/orderChecklist/update',
  BULK_COMPLETE_CHECKLIST: '/api/v1/orderChecklist/bulkComplete',
  GET_ORDER_CHECKLIST_BY_OTL: '/api/v1/orderChecklist/byOTLId/:otlId',

  // PROCESS MAPPING
  CREATE_PROCESS: '/api/v1/process/create',
  GET_ALL_PROCESSES: '/api/v1/process/listing',
  DELETE_PROCESS: '/api/v1/process/delete',
  ADD_EDIT_PROCESS_MAP: '/api/v1/processMap/addEdit',
  GET_PROCESS_MAP_BY_ID: '/api/v1/processMap/getById',
  GET_ALL_PROCESS_MAPS: '/api/v1/processMap/listing',
  SET_PROCESS_MAP_AS_DEFAULT: '/api/v1/processMap/setDefault',
  DELETE_PROCESS_MAP: '/api/v1/processMap/deleteProcessMap',
  GET_PROCESS_MAP_BY_OTL_ID: '/api/v1/orderProcessMap/listing/byOrderId/:orderId',
  ADD_EDIT_PROCESS_MAP_TO_OTL: '/api/v1/orderProcessMap/addEdit',
  GET_PROCESS_FACTORY_ASSIGN_LISTING: '/api/v1/process/factoryAssign/listing',
  ADD_EDIT_PROCESS_FACTORY_ASSIGN: '/api/v1/process/factoryAssign/addEdit',

  // Process Boards
  GET_CAPACITY_BOARD: '/api/v1/capacityBoard/listing',
  SYNC_CAPACITY_BOARD: '/api/v1/capacityBoard/sync',
  GET_CAPACITY_BOARD_STATUS: '/api/v1/capacityBoard/status',
  GET_CAPACITY_STRIP_DETAILS: '/api/v1/capacityBoard/listing/dateWise',

  GET_PLANNING_BOARD: '/api/v1/planningBoard/listing',
  PLANNING_BOARD_FILTERS_API: '/api/v1/planningBoard/filters',
  PLANNING_BOARD_FILTERS_SEARCH_API: '/api/v1/planningBoard/filters/search',
  PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID: '/api/v1/planningBoard/daywiseOrderStatus',
  SYNC_PLANNING_BOARD: '/api/v1/planningBoard/sync',
  GET_PLANNING_BOARD_STATUS: '/api/v1/planningBoard/status',
};

@Injectable({
  providedIn: 'root',
})
export class Plani8EnvironmentService {
  #API_URL: string;
  #API_REPORTS_URL: string;

  constructor(@Inject('environment') envValues: TPlani8EnvironmentVars) {
    this.#API_URL = envValues.protocol + envValues.service_host + envValues.plani8;
    this.#API_REPORTS_URL = envValues.protocol + envValues.reports_host + '/reports-v2';
  }

  public getUrlFromEnv(arg: keyof typeof Plani8EndPoints): string {
    return this.#API_URL + Plani8EndPoints[arg];
  }

  public getReportsUrl() {
    return this.#API_REPORTS_URL;
  }
}
